import { computed, ref } from 'vue'
import { Api } from "@/service/api"
import { isEmpty, isStringEmpty } from "@/service/utils"
import { ConnectionRequestBuilder } from "@/pages/CreateConnection/services/connectionRequestBuilder"
import { SOURCE_TYPES, TARGET_TYPES } from "@/pages/CreateConnection/constants/connectionTypes"

export function useConnectionUpdate(
    connection,
    yandexUpload,
    selectedYandexAccount,
    vkAdsUpload,
    selectedVKAccount,
    sourceType,
    isYandexDataInputRight,
    isVKDataInputRight,
    toaster,
    route,
    router
) {
    const isLoadingUpdating = ref(false)

    const isUpdateButtonActive = computed(() => {
        if (sourceType.value === 'GOOGLE_SHEETS') {
            for (const file of connection.value.files_source) {
                if (isStringEmpty(file.id) || isStringEmpty(file.tab.sheetId)) {
                    return false
                }
                if (file.isLoading) {
                    return false
                }
            }
        }
        else if (sourceType.value === 'YANDEX_DIRECT_STAT') {
            console.log("SOURCE TYPE YANDEX DIRECT STAT RETURN", isYandexDataInputRight.value)
            return isYandexDataInputRight.value
        }
        else if (sourceType.value === 'VKONTAKTE_CAMPAIGN_STAT') {
            return isVKDataInputRight.value
        }

        if (connection.value.filter.conditions.length > 0) {
            for (const condition of connection.value.filter.conditions) {
                if (isEmpty(condition.column)) {
                    return false
                }
                if (isEmpty(condition.criteria)) {
                    return false
                }
                if (!((isEmpty(condition.criteria) ||
                        condition.criteria.criteria_type === "IS_TRUE" ||
                        condition.criteria.criteria_type === "IS_FALSE")) &&
                    (condition.filter_value?.data === "")
                ) {
                    return false
                }
            }
        }

        if (isStringEmpty(connection.value.file_target?.id) ||
            isStringEmpty(connection.value.file_target?.tab.sheetId)) {
            return false
        }
        if (connection.value.file_target?.isLoading) {
            return false
        }
        return true
    })

    async function updateConnection() {
        if (isLoadingUpdating.value) return

        isLoadingUpdating.value = true

        try {
            let sourceUpload = []
            let account = null

            if (sourceType.value === SOURCE_TYPES.GOOGLE_SHEETS) {
                sourceUpload = connection.value.files_source
            }
            else if (sourceType.value === SOURCE_TYPES.YANDEX_DIRECT_STAT) {
                sourceUpload = yandexUpload.value
                account = selectedYandexAccount.value
            }
            else if (sourceType.value === SOURCE_TYPES.VKONTAKTE_CAMPAIGN_STAT) {
                sourceUpload = vkAdsUpload.value
                account = selectedVKAccount.value
            }

            const targetUpload = {
                spreadsheet_id: connection.value.file_target.id,
                tab_id: connection.value.file_target.tab.sheetId.toString(),
                action_type: "EXIST",
            }

            const filterUpload = connection.value.filter

            const connectionRequestBuilder = new ConnectionRequestBuilder(
                sourceUpload,
                targetUpload,
                sourceType.value,
                TARGET_TYPES.GOOGLE_SHEETS,
                filterUpload,
                account,
                null
            )

            const requestBody = connectionRequestBuilder.build()
            console.log('Request body:', requestBody)

            await Api.updateConnection(
                route.params.workflow_id,
                route.params.connection_id,
                requestBody
            )

            toaster?.success('Соединение успешно обновлено')
            router.push({
                name: 'FlowView',
                params: { workflow_id: route.params.workflow_id }
            })

        } catch (error) {
            toaster?.error(error.message || 'Ошибка при обновлении соединения')
        } finally {
            isLoadingUpdating.value = false
        }
    }

    return {
        isLoadingUpdating,
        isUpdateButtonActive,
        updateConnection
    }
}